export const TERMS_AND_PRIVACY_NOTICE_AGREEMENT = {
  existingUser: 'By using these services, I agree to the Rune Labs',
  newUser: 'By confirming my account, I agree to the Rune Labs',
}

export const COGNITO_ATTR_DEFAULT_LOGIN_PORTAL = 'custom:default_login_portal'
export const DEFAULT_LOGIN_PORTAL_STRIVE_STUDY = 'STRIVE_STUDY'
export const DEFAULT_LOGIN_PORTAL_STRIVE_STUDY_REQUIRED =
  'STRIVE_STUDY_REQUIRED'
export const STRIVE_STUDY_URL = `https://${window?.Rune?.Carrot?.config?.striveStudy?.host}`

export const COGNITO_ERRORS = {
  codeMismatchException: 'CodeMismatchException',
  invalidParameterException: 'InvalidParameterException',
  invalidPasswordException: 'InvalidPasswordException',
  userNotFoundException: 'UserNotFoundException',
}

/* Mirrors the Cognito user pool policy. Passed to the Amplify Authenticator as
 * `passwordSettings` so client-side validation matches what the server enforces.
 * Without it, Amplify falls back to its own default of 8 characters.
 */
export const PASSWORD_POLICY = { minLength: 15 }

/* Worded identically to Amplify's built-in validator output so the user sees the
 * same sentence whether the length check runs locally or comes back from Cognito.
 */
export const PASSWORD_MIN_LENGTH_MESSAGE = `Password must have at least ${PASSWORD_POLICY.minLength} characters`

export const PASSWORD_REQUIREMENTS_HEADING = 'Your password must be:'

export const PASSWORD_REQUIREMENTS = [
  `At least ${PASSWORD_POLICY.minLength} characters long`,
  'Not a common password, and not one found in a known data breach',
]

/* Verbatim messages returned by Cognito, used as I18n lookup keys to replace them
 * with the copy below. Threat protection produces `compromised`.
 */
export const COGNITO_PASSWORD_MESSAGES = {
  compromised: 'Provided password cannot be used for security reasons.',
  notLongEnough:
    'Password does not conform to policy: Password not long enough',
  notLongEnoughLegacy:
    'Password did not conform with policy: Password not long enough',
}

export const CUSTOM_ERROR_MESSAGES = {
  compromisedPassword:
    'This password appears in a known data breach or is too easily guessed. Please choose a different password.',
  email: 'This email does not exist',
  invalidPassword: 'Invalid password',
  resetPassword:
    'We are unable to reset your password at this time. Contact your account administrator and request that they send you another invite.',
  verificationCode: 'Invalid verification code',
}
